<div class="container">
  <div class="profile-wrapper">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h3>{{ currentUser?.name + ' ' + currentUser?.lastname }}</h3>
        </ion-col>
      </ion-row>
      <mat-divider></mat-divider>
      <ion-row class="profile-content">
        <ion-col size="12" size-md="6">
          <div class="form-section">
            <h5 class="form-section-title">
              <mat-icon>account_circle</mat-icon>
              <span class="title-label">{{ 'general.personalData' | translate }}</span>
            </h5>
            <form [formGroup]="currentUserForm" (ngSubmit)="submitCurrentUser()">
              <mat-form-field>
                <mat-label>{{ 'general.name' | translate }}</mat-label>
                <input matInput placeholder="Nombre..." formControlName="name">
                <mat-error *ngIf="isUserSubmitted && currentUserControls.name.errors">
                  {{ "Nombre obligatorio" }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'general.lastname' | translate }}</mat-label>
                <input matInput placeholder="Apellidos..." formControlName="lastname">
                <mat-error *ngIf="isUserSubmitted && currentUserControls.lastname.errors">
                  {{ "Apellidos obligatorio" }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'general.phone' | translate }}</mat-label>
                <input matInput placeholder="Teléfono..." formControlName="phone">
                <mat-error *ngIf="isUserSubmitted && currentUserControls.phone.errors">
                  {{ "Teléfono obligatorio" }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'general.email' | translate }}</mat-label>
                <input matInput placeholder="Email..." formControlName="email">
                <mat-error *ngIf="isUserSubmitted && currentUserControls.email.errors">
                  {{ "Email obligatorio" }}
                </mat-error>
              </mat-form-field>
              <h5 class="form-section-title">
                <mat-icon>account_circle</mat-icon>
                <span class="title-label">{{ 'general.userData' | translate }}</span>
              </h5>
              <mat-form-field>
                <mat-label>{{ 'users.role' | translate }}</mat-label>
                <input matInput placeholder="Rol..." formControlName="role">
                <mat-error *ngIf="isUserSubmitted && currentUserControls.name.errors">
                  {{ "Nombre obligatorio" }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'users.from_date' | translate }}</mat-label>
                <input matInput formControlName="registerDate">
              </mat-form-field>
              <button type="submit" [disabled]="isUserSubmitted" mat-raised-button color="primary">
                {{ 'general.submit' | translate }}
              </button>
            </form>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6">
          <div class="form-section">
            <h5 class="form-section-title">
              <mat-icon>lock</mat-icon>
              <span class="title-label">{{ 'general.changePassword' | translate }}</span>
            </h5>
            <form [formGroup]="passwordForm" (ngSubmit)="submitPasswordForm()" #pform="ngForm">
              <mat-form-field class="old-password">
                <mat-label>{{ 'general.oldPassword' | translate }}</mat-label>
                <input matInput type="password" placeholder="password actual..." formControlName="oldPassword">
                <mat-error *ngIf="passwordControls.oldPassword.touched && passwordControls.oldPassword.errors">
                  {{ "Introduzca el password actual" }}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'general.newPassword' | translate }}</mat-label>
                <input matInput type="password" placeholder="password..." formControlName="newPassword">
                <mat-error
                  *ngIf="passwordControls.newPassword.touched && passwordControls.newPassword.hasError('required')">
                  {{ "Introduzca el nuevo password" }}
                </mat-error>

                <mat-error
                  *ngIf="passwordControls.newPassword.touched && passwordControls.newPassword.hasError('minlength')">
                  {{ 'users.passwordMinLength' | translate }}
                </mat-error>
              </mat-form-field>


              <mat-form-field>
                <mat-label>{{ 'general.passwordConfirmation' | translate }}</mat-label>
                <input matInput type="password" placeholder="Contraseña..." formControlName="newPasswordConfirmation">

                <mat-error *ngIf="
                  isPasswordSubmitted &&
                  passwordControls.newPasswordConfirmation.hasError('required')
                ">
                  Introduzca de nuevo el nuevo password
                </mat-error>

                <mat-error *ngIf="
                  isPasswordSubmitted &&
                  !passwordControls.newPasswordConfirmation.hasError('required') &&
                  passwordControls.newPasswordConfirmation.hasError('minlength')
                ">
                  {{ 'users.passwordMinLength' | translate }}
                </mat-error>

                <mat-error *ngIf="
                  isPasswordSubmitted &&
                  !passwordControls.newPasswordConfirmation.errors &&
                  passwordForm.hasError('passwordMismatch')
                ">
                  {{ 'users.passwordMatchError' | translate }}
                </mat-error>

              </mat-form-field>

              <button type="submit" mat-raised-button [disabled]="isPasswordSubmitted" color="primary">
                {{ 'general.submit' | translate }}
              </button>
            </form>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>